import { CaseSourceActionTypes, IFetchCaseSourceAsyncAction } from "./caseSourceTypes"

export const fetchCaseSourcesAction = (): IFetchCaseSourceAsyncAction => {
  return {
    type: CaseSourceActionTypes.FETCH_CASE_SOURCES_ASYNC_PENDING
  }
}
